import {
  Card, CardContent, CardHeader,
  Divider,
  FormControlLabel, Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Radio, RadioGroup,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import QrBarkodPopup from 'src/components/BarcodePopup';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  content: {
    minHeight: 430,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));

function EkGaranti({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [EkGarantiTeklifDetay, setEkGarantiTeklifDetay] = React.useState([]);

  const [openQrBarkod, setOpenQrBarkod] = useState(false);
  const [QrBarkod, setQrBarkod] = useState('');
  const [TRXNumber, setTRXNumber] = useState("");
  const [olizIndirim, setOlizIndirim] = useState(0);
  const [tutar] = useState(0);
  const [satisTutar, setSatisTutar] = useState(0);
  const [discountedLogs, setDiscountedLogs] = React.useState({});
  const [currentLog, setCurrentLog] = useState(null);

  const SessionUser = getUser();


  let EkGarantiData = [];

  if (readonly) {
    EkGarantiData = Array.isArray(tasks?.tasks)
      ? tasks.tasks.filter(d => Number(d.FisNo) === Number(FisNo))
      : [];
  } else {
    const stored = loadBaslandiJob();
    EkGarantiData = Array.isArray(stored) ? stored : [];
  }



  if (!readonly && (!EkGarantiData || EkGarantiData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      EkGarantiData = loadBaslandiJob();
    }
  }

  

  let MusteriNo = EkGarantiData[0]?.MusteriNo;
  let ServiceShopId = SessionUser.ServiceShopId;
  let TechnicianId = SessionUser.TechnicianId;

  const SorgulaTeklif = (FisNo, ServiceShopId, TechnicianId, MusteriNo) => {
    setLoadingControl(true);
    axios.get('/GetArtemisEkGarantiTeklif/' + FisNo + '/' + ServiceShopId + '/' + TechnicianId + '/' + MusteriNo)
      .then(response => {
        const Deger = response.data;

        if (Deger.length === 0) {
          setEkGarantiTeklifDetay([]);
        } else {
          setEkGarantiTeklifDetay(Deger);
        }
        setLoadingControl(false);
      }).catch(error => {
        setEkGarantiTeklifDetay([]);
        setUyariTip("error");
        setUyariAciklama("Müşterimizin Ek Garanti Teklif edilebilecek ürünü bulunmamaktadır!...");
        setUyari(true);
        setLoadingControl(false);
              logger.error("Hata detayı:", error.message);
      });
  }



  useEffect(() => {
    if (!FisNo || !MusteriNo) return;

    SorgulaTeklif(
      FisNo,
      ServiceShopId,
      TechnicianId,
      MusteriNo
    );
  }, [FisNo, MusteriNo, ServiceShopId, TechnicianId]);


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleRadioChange = (event, log) => {
    const selectedValue = event.target.value;
    const selectedAmount = selectedValue === "2" ? log.YIL2 : log.YIL4;

    let Data = EkGarantiTeklifDetay.filter(e => e.KUL_MODEL_KODU !== log.KUL_MODEL_KODU);
    Data = [
      ...Data,
      {
        ...log,
        Selected: selectedValue,
        SelectedAmount: selectedAmount, // Yeni tutar bilgisi burada ekleniyor
      }
    ];

    setEkGarantiTeklifDetay(Data);

  };

  const EkGarantiSatisYapEvet = (log) => {
    setLoadingControl(true);
    setCurrentLog(log);
    const data = {
      FisNo: parseInt(FisNo),
      MODEL_KODU: log.MODEL_KODU,
      UYIL: log.UYIL,
      UDONEM: log.UDONEM.toString(),
      SERINO: log.SERINO,
      NITELIK_KODU: log.NITELIK_KODU,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TechnicianId: SessionUser.TechnicianId,
      USER_ID: SessionUser.OrganizationUserId,
      EK_GARANTI_TEKLIF: log.Selected.toString(),
      GARANTI_KALAN_SURE: log.KALAN_GUN
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisEkGarantiSatisYap', data, config)
      .then(response => {
        setLoadingControl(false);
        if (response.data.ErrorCode === "0") {
          const yeniFisNo = response.data.FisNo; // SP’den dönen yeni fiş numarası
          setUyariTip("success");
          setUyariAciklama(`İşleminiz Başarı ile Gerçekleşti! Fiş No: ${yeniFisNo}`);
          setUyari(true);

          // Eğer oliz indirim uygulanacaksa
          if (olizIndirim === 1) {
            const configOliz = { headers: { 'Content-Type': 'application/json' } };
            const olizData = {
              FisNo: yeniFisNo.toString(), // buraya SP’den gelen yeni fiş numarası gelecek
              TRXNO: TRXNumber,
              Token: QrBarkod,
              Tutar: satisTutar.toString(),
              IS_EK_GARANTI: "1"
            };
            axios.post('/SetOlizAlisverisBaslat', olizData, configOliz)
              .then((res) => {
                const olizRes = res.data;
                if (parseInt(olizRes.ErrorCode) !== 0) {
                  setUyariTip("error");
                  setUyariAciklama(olizRes.ErrorDescription);
                  setUyari(true);
                }
              })
              .catch(err => {
                setUyariTip("error");
                setUyariAciklama(err.message);
                setUyari(true);
              });
          }

          // Teklifleri tekrar yükle
          SorgulaTeklif(FisNo, ServiceShopId, TechnicianId, MusteriNo);
        } else {
          setUyariTip("error");
          setUyariAciklama(response.data.ErrorDescription);
          setUyari(true);
        }
      })
      .catch(error => {
        setLoadingControl(false);
        setUyariTip("error");
        setUyariAciklama(error.message);
        setUyari(true);
      });
  };

  const EkGarantiSatisYap = (log) => {
    if (log.Selected !== "2" && log.Selected !== "4") {
      setUyariTip("error");
      setUyariAciklama("Devam etmek için yıl seçmelisiniz!..");
      setUyari(true);
      return;
    }
    var Uyari = "Müşterimizin " + log.KUL_MODEL_KODU + "-" + log.MODEL + " ürününe ait " + log.Selected + " yıl ek garanti fişi oluşturulacaktır. Onaylıyor musunuz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => EkGarantiSatisYapEvet(log)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  // Oliz ile ödeme helper removed (unused)



  const handleQrBarkodClose = async (barkod) => {
    setOpenQrBarkod(false);
    if (barkod.length !== undefined) {
      setQrBarkod(barkod);
      handleOlizMüsteriTokenAl(barkod)
    }
  }

  const handleOlizMüsteriTokenAl = (barkod) => {
    const data = {
      FIS_NO: FisNo,
      TOKENID: barkod,
      islemTip: "4",
      param1: tutar.toString()
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/GetOlizAlisverisBaslatEkGaranti', JSON.stringify(data), config)
      .then((response) => {
        const ResponseData = response.data;

        if (ResponseData.ErrorCode === "1000") {
          setUyari(true);
          setUyariTip('error');
          setUyariAciklama(ResponseData.ErrorDescription);
          return;
        }

        const XmlData = JSON.parse(ResponseData.ErrorDescription);
        const AlisverisData = XmlData.XmlString;

        if (AlisverisData?.SONUC === "0") {
          setUyari(true);
          setUyariTip('error');
          setUyariAciklama(AlisverisData?.ACIKLAMA);
          return;
        }

        if (AlisverisData?.INDIRIM.URUNINDIRIMLIST) {
          let urunIndirimList = AlisverisData.INDIRIM.URUNINDIRIMLIST.URUNINDIRIM;
          let indirim = 0;

          // Eğer URUNINDIRIM bir dizi ise, tüm indirimleri topla
          if (Array.isArray(urunIndirimList)) {
            urunIndirimList.forEach(item => {
              let indirimTutar = item.UINDTUTAR.replace(",", ".");
              indirim += parseFloat(indirimTutar);
            });
          } else {
            // Eğer tek bir indirim varsa, direkt değeri al
            let indirimTutar = urunIndirimList.UINDTUTAR.replace(",", ".");
            indirim = parseFloat(indirimTutar);
          }

          let newPrice = AlisverisData.INDIRIM.YENIAVTUTAR.replace(",", ".");

          // İndirim yapıldıktan sonra discountedLogs state'ini güncelle
          setDiscountedLogs((prevState) => ({
            ...prevState,
            [currentLog.KUL_MODEL_KODU]: {
              YIL2: currentLog.Selected === "2" ? newPrice : parseFloat(currentLog.YIL2),
              YIL4: currentLog.Selected === "4" ? newPrice : parseFloat(currentLog.YIL4),
            },
          }));

          setTRXNumber(AlisverisData.TRXNO);
          setSatisTutar(newPrice);
          setUyari(true);
          setUyariTip('success');
          setUyariAciklama(`Oliz Ek-Garanti Kampanyası kapsamında ${tutar.toFixed(
            2
          )}₺ işlem üzerinden ${indirim.toFixed(2)}₺ indirim uygulandı.`);
          setOlizIndirim(1);
        }
      });
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={"Ek Garanti Teklif"} />
      <Divider />
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }
      <CardContent className={classes.content}>
        {
          LoadingControl ?
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
            :
            EkGarantiTeklifDetay.length === 0 ?
              <Grid container spacing={0} >
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Müşterimizin Ek Garanti Teklif edilebilecek ürünü bulunmamaktadır!...
                  </Typography>
                </Grid>
                <Grid item xs={12} align={'center'}>
                  <IconButton
                    color="primary">
                    <ClearAllIcon size="large" />
                  </IconButton>
                </Grid>
              </Grid>

              :
              <List className={classes.root}>
                {EkGarantiTeklifDetay.sort((a, b) => { return a.KUL_MODEL_KODU - b.KUL_MODEL_KODU }).map(log => (
                  <div key={log.KUL_MODEL_KODU}>
                    <ListItem alignItems="flex-start">
                      <ListItemText>
                        <Typography
                          component="span"
                          variant="body1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          <b>Garanti Bitiş Kalan Gün:</b> {log.KALAN_GUN}
                          <br />
                          <b>Marka:</b> {log.MARKA}
                          <br />
                          <b>Ürün Kodu:</b> {log.KUL_MODEL_KODU}
                          <br />
                          <b>Ürün:</b> {log.MODEL}
                          <br />
                          <RadioGroup
                            aria-label="secim"
                            name={log.KUL_MODEL_KODU}
                            onChange={(e) => handleRadioChange(e, log)}
                          >
                            <FormControlLabel
                              value="2"
                              control={<Radio color="primary" />}
                              label={
                                <span>
                                  {discountedLogs[log.KUL_MODEL_KODU]?.YIL2 ? (
                                    <>
                                      <span style={{ textDecoration: 'line-through', color: 'red' }}>
                                        2 YIL:  {log.YIL2} ₺
                                      </span>
                                      {" "}
                                      <span style={{ color: 'green' }}>
                                        {discountedLogs[log.KUL_MODEL_KODU]?.YIL2} ₺
                                      </span>
                                    </>
                                  ) : (
                                    `2 YIL: ${log.YIL2} ₺`
                                  )}
                                </span>
                              }
                            />
                            <FormControlLabel
                              value="4"
                              control={<Radio color="primary" />}
                              label={
                                <span>
                                  {discountedLogs[log.KUL_MODEL_KODU]?.YIL4 ? (
                                    <>
                                      <span style={{ textDecoration: 'line-through', color: 'red' }}>
                                        4 YIL: {log.YIL4} ₺
                                      </span>
                                      {" "}
                                      <span style={{ color: 'green' }}>
                                        {discountedLogs[log.KUL_MODEL_KODU]?.YIL4} ₺
                                      </span>
                                    </>
                                  ) : (
                                    `4 YIL: ${log.YIL4} ₺`
                                  )}
                                </span>
                              }
                            />
                          </RadioGroup>
                          <br></br>

                        </Typography>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <IconButton
                          color="primary"
                          edge="end"
                          onClick={() => EkGarantiSatisYap(log)}
                          size="small"
                        >
                          <LibraryAddIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider className={classes.divider} />
                  </div>
                ))}
              </List>
        }
      </CardContent>
      <QrBarkodPopup
        onClose={handleQrBarkodClose}
        open={openQrBarkod}
        ScanTime={0}
        CallScreen={0}
      />
    </Card >
  );
}

EkGaranti.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(EkGaranti);
